// extracted by mini-css-extract-plugin
module.exports = {"trackAxis":"trackAxis_trackAxis__oHmeJ"};